var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgKma(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.8 11.0813C18.9281 10.7469 19 10.3813 19 10C19 8.34375 17.6562 7 16 7C15.3844 7 14.8094 7.1875 14.3344 7.50625C13.4688 6.00625 11.8531 5 10 5C7.2375 5 5 7.2375 5 10C5 10.0844 5.00312 10.1688 5.00625 10.2531C3.25625 10.8688 2 12.5375 2 14.5C2 16.9844 4.01562 19 6.5 19H18C20.2094 19 22 17.2094 22 15C22 13.0656 20.625 11.45 18.8 11.0813Z",
    fill: "#171717",
    fillOpacity: 0.87
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKma);
export default __webpack_public_path__ + "static/media/kma.032b4e091b117a77530a6c0460c1df30.svg";
export { ForwardRef as ReactComponent };